import { BadgeCheck, Network } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { useCoordinatorServiceIdentity } from "@/hooks/useCoordinatorServiceIdentity";
import { cn } from "@/lib/utils";

export function CICoordinatorIdentity({
  pubkey,
  className,
  showBadge = true,
}: {
  pubkey: string;
  className?: string;
  showBadge?: boolean;
}) {
  const identity = useCoordinatorServiceIdentity(pubkey);

  return (
    <span
      className={cn("flex min-w-0 flex-wrap items-center gap-2", className)}
    >
      <span
        className={cn(
          "truncate font-medium",
          !identity?.verifiedNip05 && "font-mono text-xs text-muted-foreground",
        )}
        title={identity?.verifiedNip05 ?? identity?.npub}
      >
        {identity?.label ?? "Loading identity…"}
      </span>
      {showBadge && identity?.linkedGraspService && (
        <Badge
          variant="outline"
          className="h-5 gap-1 border-violet-500/30 bg-violet-500/10 px-1.5 text-[10px] font-medium text-violet-700 dark:text-violet-300"
          title="NIP-05 resolves to this key and the domain's NIP-11 names the same operator key"
        >
          <Network className="h-3 w-3" />
          GRASP
          <BadgeCheck className="h-3 w-3" />
        </Badge>
      )}
    </span>
  );
}
